import React from 'react'

import BadgeId from '../common/BadgeId';

export default function IssueSourceEditor({ value }) {
  return <span>
    <span className={'badge badge-light mr-1'}>{value?.type} <BadgeId large id={value.id}/></span>
  </span>;
}
